import React from "react";
import Nav from "../Nav/Nav";
import dandalsTshirt from "../../images/dandalsTshirt.png";
import "./Live.css";

const Live = (props) => {
  return (
    <React.Fragment>
      <Nav />
      <div className="live-container">
        <div className="live-picture">
          <img
            className="dandals-polaroid"
            src={dandalsTshirt}
            alt="grad-party-polaroid"
          />
        </div>
        <div className="live-details">
          {/* <div className="gig"> */}
          {/* <div className="gig-header">
              No gigs currenly on the books, will be jamming again soon!
            </div>
            {/* <div className='gig-header'>Greg's Basement - 9pm 12/31/2022</div> */}
          {/* <div className="gig-details">
              We'll be playing in a great venue near you shortly, check back
              soon!
            </div>
          </div> */}
          <div className="gig">
            <div className="gig-header">
              Sternstock at Surly Brewing - Sunday May 24th
            </div>
            <br></br>
            <div className="gig-details">
              Change of venue this year! Come join us for our annual backyard
              music festival at Surly Brewing in Minneapolis
            </div>
          </div>{" "}
          {/* <div className="gig">
            <div className="gig-header">
              Dayblock Brewery - Friday January 16th at 7pm
            </div>
            <br></br>
            <div className="gig-details">
              Come out to Dayblock Brewery and enjoy great beer, pizza and music
              from ETOVC and The Dandals!
            </div>
          </div>{" "} */}
        </div>
      </div>
    </React.Fragment>
  );
};

export default Live;
